import { VyFormSection, VyIcon } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { VySwitchField, VyTextareaField } from '../../../../../../design-system-adapters/forms';
import { FieldGrid } from '../../modify-panel-shared/layout';
import { ProductIntegrationSelectors } from '../../modify-panel-shared/selectors';
import {
  UPLIFT_UNAVAILABLE_DESCRIPTION,
  useIsUpliftAvailable,
} from '../../modify-panel-shared/hooks/use-is-uplift-available';
import { AsCreditSelector, SeatsInput } from '../selectors';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export type PricingSectionProps = {
  showAutoPriceUplift?: boolean;
  showErpSelectors?: boolean;
  showAnrok?: boolean;
  showSeats?: boolean;
  showAsCredit?: boolean;
};

export function PricingSection({
  showAutoPriceUplift = true,
  showErpSelectors = true,
  showAnrok = true,
  showSeats = false,
  showAsCredit = false,
}: PricingSectionProps) {
  const { itemIndex: productIndex } = useChargeContext();
  const isUpliftAvailable = useIsUpliftAvailable();

  return (
    <VyFormSection icon={<VyIcon icon="SectionPricing" width={20} height={20} />} title="Pricing Settings">
      <FieldGrid>
        {showAutoPriceUplift && (
          <VySwitchField<PlanInputForm>
            name={`fixedProducts.${productIndex}.upliftConfiguration.inflationaryUpliftEnabled`}
            title="Auto Price uplift"
            description={
              isUpliftAvailable ? 'Annual price lift based on inflation rate' : UPLIFT_UNAVAILABLE_DESCRIPTION
            }
            disabled={!isUpliftAvailable}
            data-field-span="full"
            data-vy="plan-charge-drawer-auto-uplift-switch"
          />
        )}

        {showSeats && <SeatsInput productIndex={productIndex} />}
        {showAsCredit && <AsCreditSelector />}

        <VyTextareaField<PlanInputForm>
          name={`fixedProducts.${productIndex}.variants.0.description`}
          label="Product description"
          placeholder="Custom note for the invoice"
          helperText="Appears alongside this item on the invoice"
          minRows={3}
          data-vy="plan-charge-drawer-description"
        />

        {/* Integration/ERP configs are not pricing-related — keep them last. */}
        <ProductIntegrationSelectors showErpSelectors={showErpSelectors} showAnrok={showAnrok} />
      </FieldGrid>
    </VyFormSection>
  );
}
